// Splash3.js
import React from "react";
import logo from "../../assets/logo.png"; 
import pharmacy_background from "../../assets/pharmacy_background1.jpeg"
import fifty from "./58.png";
export default function Splash3() {
  return (
    <div
      className="d-flex flex-column justify-content-center align-items-center vh-100 text-white"
      style={{
        backgroundImage: `url(${fifty})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      

    </div>
  );
}
